import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomSwitcher = (props) => (
  <Header {...props}>
    <span>MAF Configuration Practices</span>
  </Header>
);

export default CustomSwitcher;
